var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Room Objects')))]), _c('div', {
    staticClass: "px-4"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('Category'),
      "items": _vm.categories,
      "dense": ""
    },
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  })], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-col', {
      key: "room-objects-item-".concat(item.m_DBAccessID),
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-divider'), _c('RoomObject', {
      attrs: {
        "id": item.m_DBAccessID
      }
    })], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }